import ApiService from '../common/api.service'

class RegistrationService extends ApiService {

  register (profile) {
    return this.post('/registration', profile)
  }

  confirmRegistration (confirmation) {
    return this.post('/registration/confirm', confirmation)
  }
}

export default RegistrationService



// WEBPACK FOOTER //
// ./src/app/services/registration/registration.service.js